

export class PathPointDataOutput implements IPathPointDataOutput {
    /** The auto-generated id of the tour_coordinate_path */
    tour_coordinate_point_id!: number;
    /** The path point is coordinates for the path */
    path_point!: string;
    /** The selected path point lat */
    path_point_lat!: number;
    /** The selected path point long */
    path_point_long!: number;

    constructor(data?: IPathPointDataOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tour_coordinate_point_id = _data["tour_coordinate_point_id"];
            this.path_point = _data["path_point"];
            this.path_point_lat = _data["path_point_lat"];
            this.path_point_long = _data["path_point_long"];
        }
    }

    static fromJS(data: any): PathPointDataOutput {
        data = typeof data === 'object' ? data : {};
        let result = new PathPointDataOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tour_coordinate_point_id"] = this.tour_coordinate_point_id;
        data["path_point"] = this.path_point;
        data["path_point_lat"] = this.path_point_lat;
        data["path_point_long"] = this.path_point_long;
        return data; 
    }
}

export interface IPathPointDataOutput {
    /** The auto-generated id of the tour_coordinate_path */
    tour_coordinate_point_id: number;
    /** The path point is coordinates for the path */
    path_point: string;
    /** The selected path point lat */
    path_point_lat: number;
    /** The selected path point long */
    path_point_long: number;
}

